import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateProduct } from '../actions'
import ProductFormInput from './ProductFormInput'
import Button from './Button'

class ProductForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      feedback: {
        message: '',
        type: ''
      },
      isUpdating: false,
      updatedProduct: {
        id: '',
        name: '',
        brand: '',
        quantity: 0,
        bought: false
      }
    }
  }

  componentWillMount = () => {
    this.setState(prevState => ({
      ...prevState,
      updatedProduct: this.props.products.find(product => (
        product.id === this.props.productId
      ))
    }))
  }

  updateProductProperty = (property, value) => {
    this.setState(prevState => ({
      ...prevState,
      updatedProduct: {
        ...prevState.updatedProduct,
        [property]: value
      }
    }))
  }

  submitUpdate = () => {
    if (
      this.state.updatedProduct.name !== '' &&
      this.state.updatedProduct.brand !== '' &&
      this.state.updatedProduct.quantity !== 0
    ) {
      this.props.updateProduct(this.state.updatedProduct)

      return this.setState({
        feedback: {
          message: 'Product updated.',
          type: 'success'
        }
      })
    }

    else if (this.state.updatedProduct.quantity <= 0) {
      return this.setState({
        feedback: {
          message: 'The "quantity" field can not be less or equal to 0, please update it to 1 or more.',
          type: 'error'
        }
      })
    }

    return this.setState({
      feedback: {
        message: 'The fields "name", "brand" and "quantity" are required, please fill out those fields with valid information.',
        type: 'error'
      }
    })
  }

  render() {
    return (
      <div>
        <p>{this.state.feedback.message}</p>

        <ProductFormInput
          name='name'
          type='text'
          label='Product Name'
          placeholder='Rice'
          value={this.state.updatedProduct.name}
          onChange={this.updateProductProperty}
        />

        <ProductFormInput
          name='brand'
          type='text'
          label='Brand'
          placeholder='Broto Legal'
          value={this.state.updatedProduct.brand}
          onChange={this.updateProductProperty}
        />

        <ProductFormInput
          name='quantity'
          type='number'
          label='Quantity'
          placeholder='2'
          value={this.state.updatedProduct.quantity}
          onChange={this.updateProductProperty}
        />

        <Button
          onClick={this.submitUpdate}>
          {this.state.isUpdating ? 'Updating...' : 'Update product'}
        </Button>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    products: state.products
  }
}

export default connect(
  mapStateToProps,
  { updateProduct }
)(ProductForm);